import {
  Box as MuiBox,
  DialogContent as MuiDialogContent,
  Typography,
  type TypographyProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  paddingTop: 0,
  overflowX: "hidden",
}));

export const DialogHeader = styled(MuiBox)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "30px 0 8px",
  gap: theme.spacing(1),
  position: "sticky",
  top: "0",
  backgroundColor: theme.palette.background.paper,
  backgroundImage: "var(--Paper-overlay)",
  zIndex: 100,
}));

export const FilterRow = styled(MuiBox)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(1),
}));

export const Filter = styled(MuiBox)(({ theme }) => ({
  flexGrow: 1,
  minWidth: 0,
  maxWidth: "100%",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  alignItems: "flex-start",

  "& > .MuiToggleButtonGroup-root": {
    alignSelf: "stretch",

    "& .MuiToggleButton-root": {
      flexGrow: 1,
    },
  },

  "& > .MuiButtonBase-root": {
    alignSelf: "stretch",
  },

  "& > .MuiButtonBase-root:not(.MuiButton-root)": {
    justifyContent: "flex-start",
  },

  "& > .MuiStack-root": {
    alignSelf: "stretch",
  },

  "& > .MuiStack-root .MuiButtonBase-root": {
    flexGrow: 1,
    justifyContent: "flex-start",
  },
}));

export const FilterLabel = styled(Typography)<TypographyProps>(() => ({
  fontWeight: 500,
  fontSize: 13,
}));
